/* tslint:disable */
/* eslint-disable */
/**
 * Oil refinery process modeling system
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {mapValues} from '../runtime';
import type {ElementImportOut} from './ElementImportOut';
import {
  ElementImportOutFromJSON,
  ElementImportOutFromJSONTyped,
  ElementImportOutToJSON
} from './ElementImportOut';

/**
 *
 * @export
 * @interface ResponseStatusElementImportOut
 */
export interface ResponseStatusElementImportOut {
  /**
   *
   * @type {string}
   * @memberof ResponseStatusElementImportOut
   */
  status: string;
  /**
   *
   * @type {ElementImportOut}
   * @memberof ResponseStatusElementImportOut
   */
  data?: ElementImportOut | null;
  /**
   *
   * @type {string}
   * @memberof ResponseStatusElementImportOut
   */
  errorMsg?: string | null;
}

/**
 * Check if a given object implements the ResponseStatusElementImportOut interface.
 */
export function instanceOfResponseStatusElementImportOut(
  value: object
): value is ResponseStatusElementImportOut {
  if (!('status' in value) || value['status'] === undefined) return false;
  return true;
}

export function ResponseStatusElementImportOutFromJSON(json: any): ResponseStatusElementImportOut {
  return ResponseStatusElementImportOutFromJSONTyped(json, false);
}

export function ResponseStatusElementImportOutFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ResponseStatusElementImportOut {
  if (json == null) {
    return json;
  }
  return {
    status: json['status'],
    data: json['data'] == null ? undefined : ElementImportOutFromJSON(json['data']),
    errorMsg: json['error_msg'] == null ? undefined : json['error_msg']
  };
}

export function ResponseStatusElementImportOutToJSON(
  value?: ResponseStatusElementImportOut | null
): any {
  if (value == null) {
    return value;
  }
  return {
    status: value['status'],
    data: ElementImportOutToJSON(value['data']),
    error_msg: value['errorMsg']
  };
}
